import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../db.service';
import { slide } from '../animations';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [slide]
})
export class DashboardComponent implements OnInit {
  recentEvents:  FirebaseListObservable<any[]>;
  recentVendors: FirebaseListObservable<any[]>;
  recentPosts;

  constructor(
    private router: Router,
    private dbService: DBService
  ) {
    this.recentEvents  = dbService.getRecentEvents();
    this.recentVendors = dbService.getRecentVendors();
    this.recentPosts = dbService.getRecentForumPosts();
  }

  ngOnInit() {
  }

  showPost(post) {
    this.router.navigate([`/forums/${post.forumKey}/posts/${post.$key}`]);
  }

  showEvent(event) {
    this.router.navigate([`/calendar/${event.$key}`]);
  }

  showVendor(vendor) {
    this.router.navigate([`/vendors/${vendor.$key}`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts